export default __webpack_public_path__ + "static/media/dashboardicon.5052bf7c.svg";